var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n      }\n    ")),React.createElement("path",{"id":"ic_close_24px","className":"cls-1","d":"M15,6.007,13.993,5,10,8.993,6.007,5,5,6.007,8.993,10,5,13.993,6.007,15,10,11.007,13.993,15,15,13.993,11.007,10Z","transform":"translate(-5 -5)","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 10 10"};

module.exports = Close;

Close.default = Close;
